import UserIconSolid from '@/components/icons/UserIconSolid';
import GlobeIconSolid from '@/components/icons/GlobeIconSolid';
import PayByCheckIconSolid from '@/components/icons/PayByCheckIconSolid';
import AgreementIconSolid from '@/components/icons/AgreementIconSolid';
import { t } from 'i18next';

const getTrusteesElementConfig = (type: 'local' | 'foreign') => {
	switch (type) {
		case 'local':
			return {
				label: t('main.trustees.type.local'),
				icon: UserIconSolid,
				iconColor: 'fill-success-1000',
				iconBgColor: 'bg-success-100',
			};
		case 'foreign':
			return {
				label: t('main.trustees.type.foreign'),
				icon: GlobeIconSolid,
				iconColor: 'fill-info-1000',
				iconBgColor: 'bg-info-100',
			};
	}
};

const getAgreementsElementConfig = (type: 'purchase' | 'management') => {
	switch (type) {
		case 'purchase':
			return {
				label: t('main.agreements.type.purchase'),
				icon: PayByCheckIconSolid,
				iconColor: 'fill-success-1000',
				iconBgColor: 'bg-success-100',
			};
		case 'management':
			return {
				label: t('main.agreements.type.management'),
				icon: AgreementIconSolid,
				iconColor: 'fill-info-1000',
				iconBgColor: 'bg-info-100',
			};
	}
};

export const TrusteesUtils = {
	getTrusteesElementConfig,
	getAgreementsElementConfig
};
